import type {
  ReactElement,
} from 'react';
import styled from 'styled-components';

import { HeaderBlock } from './HeaderBlock';
import type {
  HeaderProps,
} from './types';

const StyledWrapper = styled.div({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
});

export const StyledPusher = styled.div(({
  theme: {
    layout,
  },
}) => ({
  height: layout.HEADER_HEIGHT,
}));

export function Header(props: HeaderProps): ReactElement {
  const {
    withPusher = false,
  } = props;

  return (
    <>
      <StyledWrapper>
        <HeaderBlock
          {...props}
        />
      </StyledWrapper>

      {
        withPusher && (
          <StyledPusher />
        )
      }
    </>
  );
}
